import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { AuditTicketsListPage } from 'page-components/auto-ticket/AuditTicketsListPage'

export const AuditTicketsListScreen = () => {
    const [searchParams] = useSearchParams()
    const auditId = searchParams.get('auditId')

    return <AuditTicketsListPage auditId={auditId} />
}
